export function stringToBoolean(string: string): boolean {
  return string.toLocaleLowerCase() === "true";
}
